export default __webpack_public_path__ + "static/media/vip-banner-mobile.47c595cf.webp";